module.exports = __webpack_public_path__ + "static/media/floor_tom_8.3560d486.png";